import { EventCard } from '@/components/common/eventsByCategory/components/eventCarousel/components';
import { CategoryEventsSkeleton } from './components';
import { InfiniteScroll } from '@/components/common';

const CategoryEventsSection = ({
  subTitle,
  loading,
  loadMore,
  refreshing,
  data,
  hasMore,
}: any) => {
  return (
    <div className='min-h-screen'>
      {!loading ? (
        <>
          {subTitle && (
            <div className='flex items-center py-3 text-xl font-extrabold text-gray-800 after:ms-6 after:flex-1 after:border-t after:border-gray-200 dark:text-white dark:after:border-neutral-600'>
              {subTitle}
            </div>
          )}
          <div className='flex w-full flex-col pt-4 pb-8'>
            <InfiniteScroll
              loadMore={loadMore}
              hasMore={hasMore}
              loader={refreshing ? <p>loading.....</p> : <></>}
            >
              <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6'>
                {data?.map((obj: any, index: number) => (
                  <EventCard
                    event={obj}
                    key={index}
                    className='w-full'
                  />
                ))}
              </div>
            </InfiniteScroll>
          </div>
        </>
      ) : (
        <CategoryEventsSkeleton />
      )}
    </div>
  );
};

export default CategoryEventsSection;
